module.exports = __webpack_public_path__ + "officialStatic/img/shaunghui.95623c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/shaunghui.png
// module id = Uogg
// module chunks = 0